import { ButtonBase, styled } from "@mui/material";
import useFetch from "../../../hooks/useFetch";
import React, { useEffect, useState } from "react";
import ModalEditSectors from "../../profile/additionalInfo/sectors/ModalEditSectors";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import useOpen from "../../../hooks/useOpen";

type SectorsFiltersProps = {
  preset: string[];
  onChange: (ids: string[]) => void;
  loading?: boolean;
};

type SectorItem = {
  image: string;
  label: string;
  id: string;
};

const SectorsFilters: React.FC<SectorsFiltersProps> = ({
  preset = [],
  onChange,
  loading = false,
}) => {
  const { personId: urlPersonId } = useParams();
  const personId = useSelector(
    (state: any) => urlPersonId ?? state.user?.person_id
  );
  const { isOpen, close, open } = useOpen();

  const { data: sectors, loading: sectorsLoading } = useFetch(
    "work_sectors?pagination=false",
    false,
    (data) =>
      (data?.["hydra:member"] ?? []).map(
        (sector: any): SectorItem => ({
          image: sector.image.contentUrl,
          label: sector.label,
          id: sector.id ?? sector["@id"].split("/").pop(),
        })
      )
  );

  const [selected, setSelected] = useState<SectorItem[]>([]);

  const [selectedIds, setSelectedIds] = useState<string[]>(preset);

  const handleSave = (selection: any) => {
    setSelectedIds(selection);
    onChange(selection);
  };

  useEffect(() => {
    setSelectedIds(preset);
    // onChange(preset);
  }, [preset]);

  useEffect(() => {
    if (sectors && selectedIds && selectedIds.length > 0) {
      const selectedSectors = sectors.filter((sector: SectorItem) =>
        selectedIds.includes(sector.id)
      );
      setSelected(selectedSectors);
    } else {
      setSelected([]);
    }
  }, [selectedIds, sectors]);

  const additionalInfo = { sectors: selectedIds };

  return (
    <>
      <Root
        disabled={sectorsLoading}
        onClick={open}
        $active={selected.length > 0}
      >
        Secteurs d'activité
        {/* {selected.length > 0 && (
          <span style={{ fontFamily: "Arial" }}>&nbsp;({selected.length})</span>
        )} */}
      </Root>
      <ModalEditSectors
        personId={personId}
        open={isOpen}
        onClose={close}
        additionalInfo={additionalInfo}
        sectors={sectors}
        sectorsLoading={sectorsLoading || loading}
        onSave={handleSave}
      />
    </>
  );
};

export default SectorsFilters;

const Root = styled(ButtonBase)<{ $active: boolean }>(
  ({ theme, $active }: any) => ({
    border: `${$active ? "2" : "1"}px solid`,
    fontWeight: $active ? "bold" : "normal",
    borderColor: `${theme.palette.primary.main}`,
    borderRadius: "30px",
    color: theme.palette.primary.main,
    cursor: "pointer",
    padding: "8px 16px",
    margin: "4px",
    fontSize: "13px",
    fontFamily: "Product Sans",
  })
);
